let i = 0

export default {
  /*
    <table border="1">
      <thead>
        <tr>
          <th>位</th>
          <td>8</td>
          <td>7</td>
          <td>6</td>
          <td>5</td>
          <td>4</td>
          <td>3</td>
          <td>2</td>
          <td>1</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>= 1</th>
          <td>允许修改流向</td>
          <td>允许删除流向</td>
          <td>允许添加/移动折点</td>
          <td>允许流向获取焦点</td>
          <td>允许新建流向</td>
          <td>允许删除节点</td>
          <td>允许移动节点</td>
          <td>允许节点获取焦点</td>
        </tr>
        <tr>
          <th>= 0</th>
          <td>不允许修改流向</td>
          <td>不允许删除流向</td>
          <td>不允许添加/移动折点</td>
          <td>不允许流向获取焦点</td>
          <td>不允许新建流向</td>
          <td>不允许删除节点</td>
          <td>不允许移动节点</td>
          <td>不允许节点获取焦点</td>
        </tr>
      </tbody>
    </table>
  */
  modeFilter: {
    ShapeFocus: 1,
    ShapePan: 2,
    ShapeRemove: 4,
    ShapeConnect: 8,

    LineFocus: 16,
    LinePan: 32,
    LineRemove: 64,
    LineReconnect: 128
  },

  tools: {
    hand: i++,
    marquee: i++
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/constants/index.js